"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* globals module */
/**
 * @module loginRoute
 * @description Baasic Login Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Login Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
var inversify_1 = require("inversify");
var common_1 = require("../../common");
var contracts_1 = require("../../core/contracts");
var LoginRoute = /** @class */ (function (_super) {
    tslib_1.__extends(LoginRoute, _super);
    function LoginRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        /**
         * Login route with route and query parameters.
         **/
        _this.loginRoute = 'login/{?embed,fields,options}';
        return _this;
    }
    /**
     * Parses login route which can be expanded with additional options. Supported items are:
     * - `options` - Comma separated list of options used to setup authentication token with cookie session. Supported values are: "session" and "sliding".
     * @method
     * @example loginRoute.login( {options: 'sliding'});
     **/
    LoginRoute.prototype.login = function (options) {
        return _super.prototype.baseCreate.call(this, this.loginRoute, options);
    };
    var _a;
    LoginRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], LoginRoute);
    return LoginRoute;
}(common_1.BaseRoute));
exports.LoginRoute = LoginRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route definition.
 */ 
